import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import TextDisclosure from './text-disclosure'
import ExternalDisclosure from './external-disclosure'
import NotFoundDisclosure from './not-found-disclosure'
import CheckboxDisclosure from './checkbox-disclosure'
import ChildrenModals from './children-modals'
import ChildDisclosure from './child-disclosure'

const chooseComponent = (type, child) => {
  if (child) {
    switch (type) {
      case 'text':
        return TextDisclosure
      case 'external':
      case 'file':
        return ExternalDisclosure
      case 'modal':
        return ChildDisclosure
      default:
        return ChildDisclosure
    }
  }

  switch (type) {
    case 'text':
      return TextDisclosure
    case 'external':
    case 'file':
      return ExternalDisclosure
    default:
      return TextDisclosure
  }
}

class FacadeDisclosure extends PureComponent {
  static propTypes = {
    disclosure: PropTypes.object,
    type: PropTypes.string,
    variables: PropTypes.object,
    name: PropTypes.string,
    id: PropTypes.string,
    validate: PropTypes.func,
    child: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    type: 'none',
    disclosure: null,
    variables: {},
    name: null,
    id: null,
    validate: null,
    child: false,
    className: null
  }

  static childContextTypes = {variables: PropTypes.object}

  getChildContext() {
    return {variables: this.props.variables}
  }

  renderCheckbox() {
    const {disclosure, validate, id, name} = this.props,
      checkboxProps = {uuid: disclosure.uuid, validate, id, name}

    return <CheckboxDisclosure {...checkboxProps}>{this.renderDisclosure()}</CheckboxDisclosure>
  }

  renderNotFound() {
    return <NotFoundDisclosure/>
  }

  isValidDisclosure() {
    const {disclosure} = this.props

    return disclosure && chooseComponent(disclosure.contentType)
  }

  renderContent() {
    const {type, child} = this.props

    if (!this.isValidDisclosure()) {
      this.renderNotFound()
    }

    if (child) {
      return this.renderDisclosure()
    }

    switch (type) {
      case 'checkbox':
        return this.renderCheckbox()
      default:
        return this.renderDisclosure()
    }
  }

  renderDisclosure() {
    const {disclosure, variables, child, actions, className} = this.props

    if (!disclosure) {
      return this.renderNotFound()
    }

    let disclosureProps = {disclosure, variables, actions},
      $disclosureComponent = chooseComponent(disclosure.contentType, child)

    if (this.isParentDisclosure()) {
      return (
        <React.Fragment>
          <$disclosureComponent {...disclosureProps}/>
          <ChildrenModals {...disclosureProps} className={className}/>
        </React.Fragment>
      )
    } else {
      return <$disclosureComponent {...disclosureProps}/>
    }
  }

  render() {
    const {className, child} = this.props

    if (child) {
      return <span className={className}>{this.renderContent()}</span>
    } else {
      return <div className={className}>{this.renderContent()}</div>
    }
  }

  isParentDisclosure() {
    const {child, disclosure} = this.props

    return disclosure.contentType === 'text' && !child
  }
}

export default FacadeDisclosure
